<div #text hidden>
        <ng-content></ng-content>
      </div>
      <markdown #markdown [data]="data" [isTargetBlankLinks]="true"></markdown>